import React from "react";
import "./index.css";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import {createRoot} from "react-dom/client";
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import env from "react-dotenv";

if (env.REACT_APP_STAGE !== "development" && env.REACT_APP_STAGE !== "local") {
    Sentry.init({
        dsn: "https://1518da2e1ad54b71ba15f9de06036f58@o320199.ingest.sentry.io/6536505",
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.REACT_APP_STAGE,
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.2, // recommended to be a lower value in production
        // ignoreErrors: ["UnhandledRejection",],
        // Called for message and error events
        beforeSend(event) {
            // Modify or drop the event here
            if (['AxiosError', 'UnhandledRejection'].includes(event.exception.values[0].type)) {
                // console.log('dropping Sentry event')
                return null; // don't send this event
            }
            return event;
        },

    });
}

createRoot(document.getElementById("root")).render(<React.StrictMode>
    <BrowserRouter>
        <App/>
    </BrowserRouter>
</React.StrictMode>);

